import React, { useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const ReportPage = () => {
  const location = useLocation();
  const jsonData = location.state?.jsonData;
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");

  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  const downloadCSV = () => {
    const csvContent = jsonData.children.map(node =>
      node.children.map(child => 
        `${child.image_url || 'No Image'},${child.suggestion || 'No Suggestion'}`
      ).join("\n")
    ).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${jsonData.name}_report.csv`;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  };

  return (
    <div className="report-page">
      <h2>Report for {jsonData.name}</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Image Preview</th>
            <th>Outcomes</th>
          </tr>
        </thead>
        <tbody>
          {jsonData.children.map((node, index) => (
            node.children.map((child, childIndex) => (
              <tr key={`${index}-${childIndex}`}>
                <td>
                  {child.image_url ? (
                    <img
                      src={child.image_url}
                      alt="Preview"
                      className="image-preview"
                      onClick={() => handleImageClick(child.image_url)}
                      style={{ cursor: "pointer", maxWidth: "100px" }}
                    />
                  ) : (
                    "No Image"
                  )}
                </td>
                <td>{child.suggestion ? child.suggestion : "Generate Outcomes to view"}</td>
              </tr>
            ))
          ))}
        </tbody>
      </Table>
      <Button onClick={downloadCSV} variant="success">
        Download as CSV
      </Button>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={modalImage} alt="Enlarged Preview" style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ReportPage;
